import { useLanguage } from "../contexts/LanguageContext";

function About({ name, title, imageUrl, bio}) {
  const { t } = useLanguage();
  return (
    <section
      id="about"
      className="text-center max-w-3xl mx-auto py-24 animate-fade-in"
    >
      <div className="relative inline-block group">
        <img
          className="w-48 h-48 rounded-full object-cover shadow-2xl border-4 border-gray-700/50 mx-auto transition-all duration-300 transform group-hover:scale-105 group-hover:border-cyan-400/50"
          src={imageUrl}
          alt={`${name}'s photo`}
        />
        <div className="absolute -top-2 -right-2 w-12 h-12 bg-gradient-to-r from-purple-500 to-cyan-500 rounded-full animate-pulse group-hover:scale-110 transition-transform duration-300"></div>
      </div>
      <h1 className="mt-8 text-5xl sm:text-7xl font-extrabold bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-400 p-3">
        {t('greeting')} {name}
      </h1>
      <h2 className="mt-3 text-2xl sm:text-3xl font-semibold text-gray-300">
        {title}
      </h2>
      <p className="mt-8 text-lg text-gray-400 leading-loose">{bio}</p>
    </section>
  );
}

export default About;
